import { validateUserToken } from '../services/userService';

export const validateLogin = async (navigate: Function) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    console.log("I am here 1");
    try {
       const result = await validateUserToken();
     } catch (error) {
       console.error("Error in fetching data:", error);
       localStorage.clear()
       navigate('/login');
     }
  } else {
    navigate('/login');
  }
};

export const validateLoginScreen = (navigate: Function) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    navigate("/dashboard");
  } else {
    console.log('I am here 2');
  }
};